import React, { useRef, useState } from "react";
import styled from "styled-components";
import { ImagePrincipal } from "../[id]/styles";

type Props = {
  src: string;
  alt?: string;
  zoom?: number;
  size?: number;
};

const MagnifierContainer = styled.div`
  position: relative;
  display: inline-block;
  overflow: visible;
`;

// 👇 impede que 'visible' seja passada ao DOM
const MagnifierBox = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "visible" && prop !== "size",
})<{ visible: boolean; size: number }>`
  position: absolute;
  top: 0;
  left: calc(100% + 30px);
  z-index: 50;
  width: ${(p) => p.size}px;
  height: ${(p) => p.size}px;
  border-radius: 8px;
  border: 1px solid #ccc;
  background-repeat: no-repeat;
  background-color: #fff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  display: ${(p) => (p.visible ? "block" : "none")};

  @media (max-width: 900px) {
    display: none;
  }
`;

export const ImageWithMagnifier: React.FC<Props> = ({
  src,
  alt = "",
  zoom = 0.5,
  size = 280,
}) => {
  const imgRef = useRef<HTMLImageElement | null>(null);
  const [visible, setVisible] = useState(false);
  const [backgroundPosition, setBackgroundPosition] = useState("0px 0px");
  const [backgroundSize, setBackgroundSize] = useState("0px 0px");

  const handleMouseEnter = () => {
    const img = imgRef.current;
    if (!img) return;

    const naturalWidth = img.naturalWidth;
    const naturalHeight = img.naturalHeight;
    setBackgroundSize(`${naturalWidth * zoom}px ${naturalHeight * zoom}px`);
    setVisible(true);
  };

  const handleMouseLeave = () => setVisible(false);

  const handleMouseMove = (e: React.MouseEvent) => {
    const img = imgRef.current;
    if (!img) return;

    const rect = img.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const naturalWidth = img.naturalWidth;
    const naturalHeight = img.naturalHeight;

    const posX = (x / rect.width) * (naturalWidth * zoom - size);
    const posY = (y / rect.height) * (naturalHeight * zoom - size);

    setBackgroundPosition(`-${posX}px -${posY}px`);
  };

  return (
    <MagnifierContainer>
      <ImagePrincipal
        ref={imgRef}
        src={src}
        alt={alt}
        onMouseEnter={handleMouseEnter}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        style={{ cursor: "crosshair", zIndex: 1 }}
      />
      <MagnifierBox
        visible={visible}
        size={size}
        style={{
          backgroundImage: `url(${src})`,
          backgroundSize,
          backgroundPosition,
        }}
      />
    </MagnifierContainer>
  );
};
